// Pulls a display name out of an RFC-822 From header.
//   '"Foo Bar" <foo@x.com>' → 'Foo Bar'
//   'foo@x.com'             → 'foo@x.com'
//   null                    → ''
export function parseSenderName(from: string | null | undefined): string {
  if (!from) return '';
  const match = from.match(/^"?([^"<]+?)"?\s*<.+>$/);
  if (match) return match[1].trim();
  return from.trim();
}
